import { render, staticRenderFns } from "./NewsPlayoutLayout.vue?vue&type=template&id=15778dec&scoped=true&"
import script from "./NewsPlayoutLayout.vue?vue&type=script&lang=js&"
export * from "./NewsPlayoutLayout.vue?vue&type=script&lang=js&"
import style0 from "./NewsPlayoutLayout.vue?vue&type=style&index=0&id=15778dec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15778dec",
  null
  
)

export default component.exports